import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {items} from '../items';
import {components} from '../components';

export const Reviews: React.FC = () => {
  const location = useLocation();
  const reviews = location.state?.reviews;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderHeader = (): JSX.Element => {
    return <components.Header goBack={true} title='Reviews' />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main style={{padding: '25px 0 40px 0', marginTop: 52}}>
        {reviews.map((item: any, index: number, array: any) => {
          const isLast = index === array.length - 1;
          return <items.ReviewItem isLast={isLast} item={item} />;
        })}
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
